import { Box } from '@material-ui/core'
import { useRootStyles } from './styles'

const Root = ({ children }) => {
  const styles = useRootStyles()
  return <Box className={styles.container}>{children}</Box>
}

export default Root
